<template>
  <div>
    <div class=" container">
      <el-button @click="openDialogs">新增</el-button>
      <el-button @click="allDel">删除</el-button>
      <el-table stripe v-loading="loading" class="tables" ref="multipleTable" :data="tableData" border
        tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="日期">
          <template slot-scope="scope">{{ scope.row.creationTime }}</template>
        </el-table-column>
        <el-table-column prop="title" label="标题" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="popularity" label="热度" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="summary" label="摘要" show-overflow-tooltip>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <span class="menu-button" @click="openEdit(scope.row)">编辑</span>
            <el-popconfirm cancel-button-type="button" title="确定删除数据吗？" @confirm="del(scope.row)">
              <span class="menu-button" slot="reference" style="margin-left: 20px;">删除</span>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center;margin-top: 50px;">
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
          :current-page.sync="currentPage" :page-size="10" :total="total">
        </el-pagination>
      </div>

    </div>
    <!-- 弹窗 -->
    <el-dialog title="" :visible.sync="dialogVisible" width="50%">
      <el-form ref="form" :rules="rules" style="width: 100%" :border="true" label-width="130px" :model="formLabel">
        <el-form-item label="标题" prop="title">
          <el-input v-model="formLabel.title"   maxlength="40"   show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="日期" prop="creationTime">
          <el-date-picker v-model="formLabel.creationTime" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="摘要" prop="summary">
          <el-input v-model="formLabel.summary"></el-input>
        </el-form-item>
        <el-form-item label="热度"  prop="popularity">
          <el-input v-model="formLabel.popularity" type="number"></el-input>
        </el-form-item>
        <!-- <el-form-item label="链接地址" prop="url">
          <el-input v-model="formLabel.url"></el-input>
        </el-form-item> -->
        <el-form-item label="宣传彩页" prop="advertisingPic">
          <el-upload class="avatar-uploader" action="" :http-request="getToken" :on-error="uploadError"
            :on-change="onProgress" :on-success="uploadSuccess" :show-file-list="false">
            <img v-if="formLabel.advertisingPic" :src="formLabel.advertisingPic" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeData">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request';
import { getLearningMaterialList, DeleteLearnMaterials } from '@/api/tables/tables';
var moment = require('moment');
const qiniu = require("qiniu-js");
export default {
  name: "training",
  props: ['userId'],
  watch: {
    userId: {
      immediate: true,
      handler(newData, oldData) {
        this.user = newData;;
      },
    }
  },
  components: {
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      id: '',
      user: '',
      loading: true,
      type: "add",
      formLabel: {
        title: '',
        creationTime: "",
        popularity: '',
        summary: '',
        advertisingPic: '',
        // url: "",
      },
      qiniuData: {
        token: '',
        bucket: '',
        root: '',
      },
      dialogVisible: false,
      tableData: [],
      multipleSelection: [],
      rules: {
        creationTime: [
          { required: true, message: '请输入日期', trigger: 'blur' },
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        summary: [
          { required: true, message: '请输入摘要', trigger: 'blur' }
        ],
        popularity: [
          { required: true, message: '请输入热度', trigger: 'blur' }
        ],
        advertisingPic: [
          { required: true, message: '请选择图片', trigger: 'blur' }
        ],
        // url: [
        //   { required: true, message: '请输入链接地址', trigger: 'blur' }
        // ],
      }

    };
  },
  created() {
    this.getList();
  },
  methods: {
    getToken(upload) {
      request({
        url: 'api/LearningMaterials/QiniuToken',
        method: 'post',
      }).then((res) => {
        if (res.data.success) {
          this.qiniuData.token = res.data.data.token
          this.qiniuData.bucket = res.data.data.bucket
          this.qiniuData.root = res.data.data.root
          this.qiniuUpload(upload, res.data.data.token, res.data.data.bucket)
        }
      })
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: "出错，请重试！",
        type: "error",
        center: true,
      });
    },
    // 上传成功 
    uploadSuccess(response, file, fileList) {
      // console.log(response);
    },
    onProgress(e) {
    },
    // 上传
    qiniuUpload(upload, token, bucket) {
      let time = Date.now()
      let key = "pspWeb/uploadFile/" + time + upload.file.name;
      // console.log(key);
      const _this = this;
      let putExtra = {};
      let config = { useCdnDomain: true, region: qiniu.region.z0 };
      // file:图片数据;key:图片名称;token:服务端获取的token;putExtra:额外的参数;config:其他配置
      let observable = qiniu.upload(
        // bucket,
        upload.file,
        key,
        token,
        putExtra,
        config
      );
      let error = function (err) {
        console.log(err)
        _this.$message({
          message: "上传出错",
          type: "error",
        });
      };
      let complete = function (res) {
        _this.formLabel.advertisingPic = _this.qiniuData.root + res.key;
      };
      let next = function (response) { };
      let subObject = {
        next: next,
        error: error,
        complete: complete,
      };
      let subscription = observable.subscribe(subObject);

    },
    getList() {
      getLearningMaterialList({
          "pageIndex": this.currentPage,
          "pageSize": this.pageSize,
          "materialType": 2,
          "industryExpertId": this.user,
        })
      .then((res) => {
        if (res.data.success) {
          this.loading = false
          var item = res.data.data.items.map((item) => {
            item.creationTime = moment(item.creationTime).format("YYYY-MM-DD");
            return item
          })
          this.tableData = item
          this.total = res.data.data.totalCount
        }
      })
    },
    // 打开弹窗页
    openDialogs() {
      this.type = "add"
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      })
    },
    // 页数切换
    handleCurrentChange() {
      this.loading = true
      setTimeout(() => {
        this.getList()
      }, 400);
    },
    // 编辑数据 
    openEdit(row) {
      this.type = "edit"
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.id = row.id
        this.formLabel = JSON.parse(JSON.stringify(row));;
      })
    },
    changeData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            var obj = {
              "title": this.formLabel.title,
              "summary": this.formLabel.summary,
              "materialType": 2,
              "popularity": this.formLabel.popularity,
              "url": "1",
              "creationTime": moment(this.formLabel.creationTime).format("YYYY-MM-DD"),
              "advertisingPic": this.formLabel.advertisingPic,
              "industryExpertId": this.user
            }
          } else {
            var obj = {
              "id": this.id,
              "title": this.formLabel.title,
              "summary": this.formLabel.summary,
              "materialType": 2,
              "popularity": this.formLabel.popularity,
              "url": "1",
              "creationTime": moment(this.formLabel.creationTime).format("YYYY-MM-DD"),
              "advertisingPic": this.formLabel.advertisingPic,
              "industryExpertId": this.user
            }
          }
          request({
            url: this.type == 'add' ? 'api/LearningMaterials/AddLearningMaterial' : 'api/LearningMaterials/UpdateLearningMaterial',
            method: 'post',
            data: obj
          }).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success'
              });
              this.loading = true;
              setTimeout(() => {
                this.getList();
              }, 1000);

            } else {
              this.$message.error('失败！');
            }
          })
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    del(row) {
      DeleteLearnMaterials({
          ids: [row.id]
        })
      .then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: 'success'
          });
          this.loading = true;
          setTimeout(() => {
            this.getList();
          }, 1000);

        } else {
          this.$message.error('失败！');
        }
      },
      )
    },
    allDel() {
      if (this.multipleSelection.length <= 0) {
        this.$message({
          message: '至少选择一条数据',
          type: 'warning'
        });
        return;
      }
      var ids = this.multipleSelection.map((item) => {
        return item.id
      })
      DeleteLearnMaterials({
          ids: ids
        })
      .then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: 'success'
          });
          this.loading = true;
          setTimeout(() => {
            this.getList();
          }, 1000);

        } else {
          this.$message.error('失败！');
        }
      },
      )
    },
    // 多选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },

};
</script>

<style lang="scss" scoped>
.tables {
  margin-top: 30px;
}

.menu-button {
  color: #2970EC;
  cursor: pointer;

}

::v-deep.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
